<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
        <el-breadcrumb-item>员工及格率</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="searchForm">
          <!-- <el-form-item>
            <el-input type="test" v-model="searchForm.emp" placeholder="企业"></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-select  v-model="searchForm.testId" filterable  placeholder="试卷名称">
                <el-option v-for='(item,index) in tests' :key="index" :label="item.title" :value="item.id"></el-option> 
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="handleSearch">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>

      <!--列表-->
      <el-table :data="reports" highlight-current-row v-loading="loading" border style="width: 100%;">
        <el-table-column type="index" label="序号" width="60" fixed="left" align="center"></el-table-column>
        <el-table-column prop="orgName" label="企业" align="center" width="280" ></el-table-column>
        <el-table-column prop="testName" label="试卷名称"  align="center" ></el-table-column>
        <el-table-column prop="empTotalCount" label="总员工" width="150" align="center"></el-table-column>
        <el-table-column prop="joinEmpCount" label="参加考试员工" width="150" align="center"></el-table-column>
        <el-table-column prop="examTotalCount" label="应总考试数" width="150" align="center"></el-table-column>
        <el-table-column prop="joinExamCount" label="已参加考试数" width="150" align="center"></el-table-column>
        <el-table-column prop="passExamCount" label="通过考试总数" width="150" align="center"></el-table-column>
        <el-table-column prop="joinRate" label="考试率(%)" width="150" align="center"></el-table-column>
        <el-table-column prop="passRate" label="通过率(%)" width="150" align="center"></el-table-column>
      </el-table>

      <!--分页工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]"
          :page-size="10" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
      </el-col>
    </el-col>
  </el-row>
</template>

<script>
import util from '../../common/util'
import API from '../../api/exam/api_exam_report';
export default {
    data(){
        return{
            formatter:{
                
            },
            reports:[],
            tests:[],
            loading:false,
            total: 0,
            page: 1,
            limit: 10,
            //查询条件
            searchForm:{
                orgId:'',
                testId:''
            },
        }       
    },
    methods:{
        init:function(){
            let that = this;
            let params={};
            //加载
            API.getTestPaper(params)
                .then(
                    function (result) {
                        that.loading = false;
                        if (result && result.code == 200) {
                            that.tests=result.data;
                        }
                    },
                    function (err) {
                    that.loading = false;
                    that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000
                    });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    console.log(error);
                    that.$message.error({
                    showClose: true,
                    message: "请求出现异常",
                    duration: 2000
                    });
                });
        },
        //分页切换每页条数
        handleSizeChange:function(val){
            this.limit = val;
            this.search();
        },
        //分页切换页码
        handleCurrentChange:function(val){
            this.page = val;
            this.search();
        },
        //查询函数
        search:function(){
            let that = this;
            let params = {
                page: this.page,
                limit: this.limit,
                orgId:that.searchForm.orgId,
                testId:that.searchForm.testId
            };
            //加载
            API.getOrgExamReport(params)
                .then(
                    function (result) {
                    that.loading = false;
                    if (result && result.code == 200) {
                        if(result.data  && result.data.records)
                        {
                            that.total= result.data.total;
                            that.reports=result.data.records;
                        }
                    }
                    },
                    function (err) {
                    that.loading = false;
                    that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000
                    });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    console.log(error);
                    that.$message.error({
                    showClose: true,
                    message: "请求出现异常",
                    duration: 2000
                    });
                });
        },
        
        //查询
        handleSearch:function(){
            this.page=1;
            this.total=0;
            this.search();
        }
    },
    //页面load加载
     mounted() {
      this.handleSearch();
      this.init();
    }
}
</script>


// WEBPACK FOOTER //
// orgReport.vue?2a4320ef